import { PeekyElement } from '@front/peeky/peeky.element';

export class Chain {
  private e: PeekyElement;
  private _queue = [];
  private _done = [];
  private _running = false;
  private _input: any = {};
  private _err?: any;

  constructor(element, input?) {
    this.e = element;
    this._input = input;
  }

  triggerAction(name, param, callback) {
    if (typeof(callback) === 'function') {
      this._done.push(callback);
    }
    this._queue.push((input) => {
      this.e.triggerAction(name, param || {}, function(err, output) {
        if (err) {
          this.stop(err, output);
        } else {
          this.next(err, output);
        }
      });
    });
    if (!this._running) {
      this.next(this._err, param || this._input || {});
    }
  }


  then(func) {
    this._queue.push(func);
    if (!this._running) {
      this.next(this._err, this._input || {});
    }
    return this;
  }


  done(callback?: Function) {
    this._done.push((err, res) => {
      if (!err) {
        err = this._err;
      }
      if (!res) {
        res = this._input;
      }
      this._err = this._input = undefined;
      if (callback) {
        callback.call(this.e, err, res);
      }
    });
    if (!this._running) {
      this.next(this._err, this._input || {});
    }
    return this;
  }


  async next(err, input) {
    this._running = true;
    if (err) {
      this._err = err;
    }
    if (input) {
      this._input = input;
    } else {
      input = this._input;
    }
    let next = (err, input) => {
      return this.next.call(this, err, input);
    };
    let stop = (err, input) => {
      return this.stop.call(this, err, input);
    };
    if (this._queue.length > 0) {
      let func = this._queue.shift();
      await func.call(this.e, input, next, stop);
    } else {
      while (this._done.length > 0) {
        let func = this._done.shift();
        await func.call(this.e, err, input);
      }
      this._running = false;
    }
  }

	
  stop(err, output) {
    this._running = false;
    this._queue = [];
    this.next(err, output);
  }
};

